import React from "react";

interface AlternativeDrugsSectionProps {
  drugs: string[];
}

/**
 * Displays alternative drugs as pill-shaped chips.
 */
const AlternativeDrugsSection: React.FC<AlternativeDrugsSectionProps> = ({
  drugs,
}) => (
  <div className="flex flex-col gap-3">
    <p className="text-[11px] font-bold uppercase tracking-[0.6px] text-[#3D3D3D]">
      Alternative Drugs
    </p>
    <div className="flex flex-wrap gap-2">
      {drugs.map((drug, idx) => (
        <span
          key={idx}
          className="rounded-full border border-[#E6E6E6] bg-[#F7F9FA] px-4 py-2 text-[13px] font-bold text-[#1F1F1F]"
        >
          {drug}
        </span>
      ))}
    </div>
  </div>
);

export default AlternativeDrugsSection;
